import React, { useState, useEffect } from 'react';

import Markdown from 'markdown-to-jsx';
import { styled } from 'styled-components';
import { useNavigate } from 'react-router';
import CustomMarkdown from 'core/components/global/markdown/markdown';


function DocsViewer({target}) {
    const [post, setPost] = useState('');

    // Select the page
    let file_name;
    if (target === "general") {
        file_name = 'general.md';
    } else if (target === "demo"){
        file_name = 'demo.md';
    } else {
        file_name = 'main.md';
    }
    
    // Import the file in this component
    useEffect(() => {
        import(`./${file_name}`)
            .then(res => {
                fetch(res.default)
                    .then(res => res.text())
                    .then(res => setPost(res))
                    .catch(err => console.log(err));
            })
            .catch(err => console.log(err));
    }, []);

    return (
        // Show the file as formatted markdown
        <div className='p-3'>
            <CustomMarkdown content={post}/>
          {/* <CustomMarkdown>
              <Markdown>
                  {post}
              </Markdown>
          </CustomMarkdown> */}
        </div>
    );
}

export default DocsViewer;
